module.exports = __webpack_public_path__ + "img/modal-success.1ec3458d.jpg";